import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';

const CLIENT_ID = process.env.REACT_APP_DISCORD_CLIENT_ID;
const REDIRECT_URI = process.env.REACT_APP_DISCORD_REDIRECT_URI;

const Header = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [user, setUser] = useState(null);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleScroll = () => {
    setScrolled(window.scrollY > 50);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    const storedUser = localStorage.getItem('discord_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }

    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowUserDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('discord_user');
    setUser(null);
    setShowUserDropdown(false);
    navigate('/');
  };

  // Fungsi untuk handling navigasi
  const handleNavClick = (e, sectionId) => {
    e.preventDefault(); // Mencegah default behavior dari link
    setIsOpen(false);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      // Update URL tanpa hash
      window.history.pushState({}, '', '/');
    }
  };

  const discordAuthUrl = `https://discord.com/api/oauth2/authorize?client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(
    REDIRECT_URI
  )}&response_type=code&scope=identify%20email%20guilds`;

  const UserSection = ({ isMobile }) => (
    <div className={`user-section ${isMobile ? 'mobile' : ''}`}>
      {user ? (
        <>
          {isMobile ? (
            // Mobile view
            <>
              <div className="user-profile">
                <img
                  src={`https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png`}
                  alt="User Avatar"
                  className="user-avatar"
                />
                <span className="user-name">{user.username}</span>
              </div>
              <button onClick={handleLogout} className="auth-button logout">
                LOGOUT
              </button>
            </>
          ) : (
            // Desktop view
            <div className="user-dropdown-container" ref={dropdownRef}>
              <div 
                className="user-avatar-container" 
                onClick={() => setShowUserDropdown(!showUserDropdown)}
              >
                <img
                  src={`https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png`}
                  alt="User Avatar"
                  className="user-avatar"
                />
              </div>
              {showUserDropdown && (
                <div className="user-dropdown">
                  <div className="dropdown-user-info">
                    <span className="dropdown-username">{user.username}</span>
                  </div>
                  <button onClick={handleLogout} className="dropdown-logout-button">
                    Logout
                  </button>
                </div>
              )}
            </div>
          )}
        </>
      ) : (
        <a href={discordAuthUrl} className="auth-button login">
          LOGIN
        </a>
      )}
    </div>
  );

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="logo">
        <img src="/icon/TFH.png" alt="TFH Prow Logo" />
        <span>TFH Prow</span>
      </div>

      <div className={`hamburger ${isOpen ? 'active' : ''}`} onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>

      <nav className={`nav ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <UserSection isMobile={true} />
        </div>
        <ul className="nav-links">
          <li><a href="#home" onClick={(e) => handleNavClick(e, 'home')}><i className="fas fa-home"></i> Home</a></li>
          <li><a href="#gallery" onClick={(e) => handleNavClick(e, 'gallery')}><i className="fas fa-images"></i> Gallery</a></li>
          <li><a href="#member" onClick={(e) => handleNavClick(e, 'member')}><i className="fas fa-users"></i> Member</a></li>
          <li><a href="#about" onClick={(e) => handleNavClick(e, 'about')}><i className="fas fa-info-circle"></i> About</a></li>
        </ul>
      </nav>

      <div className="desktop-user">
        <UserSection isMobile={false} />
      </div>

      <div className={`overlay ${isOpen ? 'show' : ''}`} onClick={() => setIsOpen(false)}></div>
    </header>
  );
};

export default Header;